// return true/false if is rtl

export function is_rtl(){

	return jQuery('body').hasClass('rtl');

}



export function setCookie(cname,cvalue,exdays) {

    var d = new Date();

    d.setTime(d.getTime() + (exdays*24*60*60*1000));

    var expires = "expires=" + d.toGMTString();

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

}



export function getCookie(cname) {

    var name = cname + "=";

    var decodedCookie = decodeURIComponent(document.cookie);

    var ca = decodedCookie.split(';');

    for(var i = 0; i < ca.length; i++) {

        var c = ca[i];

        while (c.charAt(0) == ' ') {

            c = c.substring(1);

        }

        if (c.indexOf(name) == 0) {

            return c.substring(name.length, c.length);

        }

    }

    return "";

}



export function checkCookie(cname) {

    var user_voted=getCookie(cname);

	$is_voted = 0;

    if (user_voted != "") {

		$is_voted = 1;

    } else {

       user_voted = 1;

       if (user_voted != "" && user_voted != null) {

           setCookie(cname, user_voted, 1);

       }

    }

	return $is_voted;

}

export default { is_rtl, setCookie, getCookie, checkCookie }